module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.961 13.961\"><defs><style> .ce-a{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:1.1px;} </style></defs><g transform=\"translate(-414 -641)\"><circle cx=\"6.98\" cy=\"6.98\" r=\"6.98\" transform=\"translate(414 641)\"></circle><g transform=\"translate(420.741 643.792) rotate(45)\"><line class=\"ce-a\" y2=\"5.584\" transform=\"translate(2.792)\"></line><line class=\"ce-a\" y2=\"5.584\" transform=\"translate(5.584 2.792) rotate(90)\"></line></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./uncommon-client/components/svgs/icon-cancel-edit.svg
// module id = 5CGU
// module chunks = 1